import {
  CreditAssist,
  getDocumentStatus,
  getRedirctionSahmati
} from "@Redux/Manual_Kyc_Details/action";
import "@Styles/mandate.css";
import React, { useEffect, useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import { connect } from "react-redux";
import { useLocation, useNavigate } from 'react-router-dom';
import { withRouter } from "../../../hooks/withRouter";
import {
  getUserDetail,
  getWhatsappNumber,
  updateWhatsappNumber,
} from "../../../Redux/GeneralDetails/action";
import ToastMsg from "../../../helper/ToastMsg";
import { WHATSAPPHEADING } from "../Common/constant";


const VerifyWhatsApp = (props) => {
  const navigate = useNavigate();
  let token =(props?.user && props?.user?.User && props?.user?.User?.token) ||     localStorage.getItem("gpay_token");
const [customerNumber, setCustomerNumber] = useState("");
const [loader, setLoader] = useState(false);
const [isWhatsAppNumber , setisWhatsAppNumber    ] = useState(false);
const [clickedOnNo, setClickedOnNo] = useState(false);
const [phone_number, setmobileNumber] = useState("");
const [clickedonYes, setClickedonYes] = useState(false);
const [isWhatsAppNumberNew, setIsWhatsAppNumberNew] = useState("");
const [can_apply_for_loan, setCan_apply_for_loan] = useState(false);
const [receivedKey, setreceivedKey] = useState("");
  const [sehmatiOpen, setSehmatiOpen] = useState(false);

  const [state, setState] = useState({
    is_enable: false,
    isChecked: false,
  });
const mobileNoRegex = /^[0-9\b]+$/;

const location = useLocation();
  useEffect(() => {
    const searchParams = new URLSearchParams(props.location.search);
    const receivedKeyhere = searchParams.get('key');
    setreceivedKey(receivedKeyhere)
    
       

   
        getDocStatus(token)
        props.getWhatsappNumber(token)
    
        .then((res) =>{
          setCustomerNumber(res?.data?.data?.phone_number)
          // window.location.href = "/dashboard_s";
        })
        .catch((err)=>{
          // alert("insidegetwhatapperr")
          let error = err;
          ToastMsg(error, "error");
        })

       

  }, []);
  const handleLogout = () => {
    localStorage.clear()
    window.location.href = "/";
  };

  const creditAssistRedirection = () =>{
    props.CreditAssist(token)
                .then((res) => {
                  // console.log(res.data.url,"crediturlllll");
                  var url = res.data.url;
                  handleLogout()

                  const timeoutId = setTimeout(() => {
                    handleLogout();
                  }, 2000);

                  window.open(url, '_blank');
                  // window.location.href=res.data.url
                  // window.open(res.data.url);
                })
                .catch((err) => {
                  setState({ loader: false });
                  if (err.response?.status === 401) {
                  window.location.href = "/";
                    localStorage.removeItem("gpay_token");
                  }
                  let error = err?.response?.data?.error;
                  ToastMsg(error, "error");
                  // console.log(err);
                });
  }
  const getDocStatus = (token) =>{
    
    props
    .getDocumentStatus(token)
    .then((res) => {
      // console.log(res?.data[0]?.can_apply_for_loan, "getdocstatus");
      setCan_apply_for_loan(res?.data[0]?.can_apply_for_loan)

      
    })
    .catch((err) => {
      if (err.response?.status === 401) {
        window.location.href = "/";
        localStorage.removeItem("gpay_token");
      }
      let error = err?.response?.data?.error;
      ToastMsg(error, "error");
      // console.log(err);
    });
  }
  const handleredirection = (token) =>{
    props
    .getUserDetail(token)
    .then((res) => {
      setLoader(false)
      let customusermodel = res?.data?.data?.customusermodel;
      let creditData = res?.data?.data?.customusermodel?.usercredit;
      // console.log(
      //   "usercredit",
      //   res.data.data.customusermodel.usercredit
      // );

      let { usercredit, user_level } = customusermodel
        ? customusermodel
        : "";

      if (
        creditData.length !== 0 &&
        creditData[0].credit_limit > 0 &&
        customusermodel.blocked === false &&
        can_apply_for_loan
      ) {
        //alert("inside congo")
        // nv(
        //   "event",
        //   "Credit Limit assigned",
        //   { "Credit Limit Amount": creditData[0]?.credit_limit },
        //   "100",
        //   1
        // );
       
        if (receivedKey === "CREDIT_CARDS"){
          navigate(`/axis-bank`);
        }
        else if(receivedKey === "CREDIT_ASSIST"){
          creditAssistRedirection(token)
        }
        else{
          navigate(`/congratulation`);
        }

      } else if (customusermodel.blocked) {
        
        // nv(
        //   "event",
        //   "Credit Limit rejected",
        //   { Status: "Rejected" },
        //   "100",
        //   1
        // );

      
        let bankData = {
          heading: "Sorry !",
          subHeading: "You are ineligible for loans at the moment.",
          message: "Please try after 6 months.",
          but_name: "Update",
          route: "cibil",
        };
        if(receivedKey === "CREDIT_CARDS"){
          navigate(`/axis-bank`);
        }
        else{
          creditAssistRedirection(token)
          setLoader(false)
        }
        // this.props.history.push(
        //   `/not_eligible_for_loan?msg=${JSON.stringify(bankData)}` 
        // );
      } else {
        //alert("inside dashboard")
        // nv(
        //   "event",
        //   "Credit Limit review",
        //   { Status: "Review" },
        //   "100",
        //   10
        // );
        

        let bankData = {
          heading: "Under Review!",
          subHeading: "",
          message:
            "We're still reviewing your details and assessing your loan limit. We'll get back to you soon with an update.",
          but_name: "Continue",
          route: "cibil",
        };
        navigate(`/dashboard_s`);
      }
    })
    .catch((err) => {
      setLoader(false)
      if (err.response?.status === 401) {
        window.location.href = "/";
        localStorage.removeItem("gpay_token");
      }
      let error = err?.response?.data?.error;
      ToastMsg(error, "error");
      // console.log(err);
    });
  }

  const handlegetUpdateexistingNumver = () =>{
    
    let token =
    (props?.user && props?.user?.User && props?.user?.User?.token) ||
    localStorage.getItem("gpay_token");
  {clickedonYes ?
    
    props.updateWhatsappNumber ( customerNumber, token)
    .then((res)=>{
      // console.log(res);
      handleredirection(token)
    })
    .catch((err)=>{
      let error = err;
      ToastMsg(error, "error");
    })
    :
    props.updateWhatsappNumber ( phone_number, token)
    .then((res)=>{
      // console.log(res);
      handleredirection(token)
    })
    .catch((err)=>{
      let error = err;
      ToastMsg(error, "error");
    })
  }}
  
  const handleWhatsAppYes=() =>{
   
    setClickedonYes(true);
    setisWhatsAppNumber(true);
    setClickedOnNo(false);
  };
  const handleWhatsAppNO = (e) => {
   
    setClickedonYes(false);
    setisWhatsAppNumber(false);
    setClickedOnNo(true);
    setIsWhatsAppNumberNew(e.target.value);
    // console.log(isWhatsAppNumber, "isWhatappnumber");
  };
  const setPhone = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    let arr = ["6", "7", "8", "9"];
    if (value === "" || mobileNoRegex.test(value)) {
      if (arr.includes(value[0]) || value === "" || value[1]) {
        if (value[0] === "0") {
          setmobileNumber(value.slice(1, 11));
          if (value.length >= 10) {
          }
        } else {
          setmobileNumber(value.slice(0, 10));
          if (value.length >= 10) {
          }
        }
      }
      if (value.length === 10 && value[0] !== "0") {
        setState({ is_enable: true });
        // console.log(phone_number, "userphonenumber");
        setisWhatsAppNumber(true);
        if (value === customerNumber) {
          setisWhatsAppNumber(false);

          ToastMsg(
            "WhatsApp number should be different from registered mobile number"
          );
          setTimeout(() => {
            setmobileNumber("");
          }, 4000);
        }
      } else {
        setisWhatsAppNumber(false);
        setState({ is_enable: false });
      }
    }
  };

  return (
    <div style={{ display: "flex" }} className="containerWhatapp">
      <div className="shadowlinenew">
        <div className="styleCenter">
          <h1
            className="boldheading"
            style={{
              whiteSpace: "nowrap",
              paddingTop: "38px",
              marginBottom: "25px",
              color: "#152745",
              fontWeight: "700",
              fontSize: "30px",
            }}
          >
            {WHATSAPPHEADING}
          </h1>
        </div>
      </div>

      <div className="aligncentree">
        <div className="supportmajor">
          <div style={{ marginRight: "0px" }}>
            <div>
              <p className="supportheading">
                Is
                <span
                  className="supportsubheadingemail"
                  style={{ marginLeft: "5px" }}
                >
                  {customerNumber}
                </span>{" "}
                is your WhatsApp Number?
              </p>
            </div>

            <div className="flexdefault">
              <div className="flex align-center">
                <input
                  type="radio"
                  name="paymecolour"
                  onClick={handleWhatsAppYes}
                  style={{ width: "21px", height: "21px" }}
                />
                <label
                  style={{
                    paddingLeft: "5px",
                    paddingRight: "36px",
                    fontSize: "16px",
                  }}
                >
                  Yes
                </label>
              </div>

              <div className="flex align-center">
                <input
                  type="radio"
                  name="paymecolour"
                  onClick={(e) => handleWhatsAppNO(e)}
                  style={{ width: "20px", height: "20px" }}
                />
                <label style={{ paddingLeft: "5px", fontSize: "16px" }}>
                  No
                </label>
              </div>
            </div>
          </div>

          {!isWhatsAppNumber && !clickedOnNo ? (
            <span className="supportendline">
              We recommend you to provide your{" "}
              <span
                className="supportsubheadingemail"
                style={{ marginLeft: "5px", fontSize: "12px" }}
              >
                WhatsApp
              </span>{" "}
              number so that PayMe can improve your experience by communicating
              updates about payments and offers on{" "}
              <span
                className="supportsubheadingemail"
                style={{ marginLeft: "5px", fontSize: "12px" }}
              >
                WhatsApp
              </span>
              .
            </span>
          ) : isWhatsAppNumber ? (
            <div style={{ height: "0px" }}></div>
          ) : (
            ""
          )}
          {clickedOnNo ? (
            <>
              <label
                style={{ fontSize: "18px", fontWeight: "500" }}
                className="nineonewhatapp"
              >
                +91 |
              </label>
              <input
                style={{
                  paddingLeft: "40px",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
                type="text"
                maxLength={10}
                value={phone_number}
                onChange={setPhone}
                placeholder="Provide Your WhatsApp No"
                className="whatappsInput mbottom-30 placeholder-style"
              />
              <br />
              <span className="supportendline ">
                By proceeding, you authorise PayMe to communicate updates about
                payments and offers on{" "}
                <span
                  className="supportsubheadingemail"
                  style={{ marginLeft: "5px", fontSize: "12px" }}
                >
                  WhatsApp
                </span>{" "}
                .
              </span>
            </>
          ) : (
            ""
          )}
          {isWhatsAppNumber ? (
            <div className="centerawhatapp">
              <div
                style={clickedonYes ? { marginTop: "183px" } : {}}
                onClick={handlegetUpdateexistingNumver}
                className={
                  !isWhatsAppNumber
                    ? "whatappverifybtn center"
                    : "whatappverifybtnOther center"
                }
              >
                Verify
              </div>
            </div>
          ) : (
            <div className="centerawhatapp blur">
              <div
                className={
                  !isWhatsAppNumber
                    ? "whatappverifybtn center"
                    : "whatappverifybtnOther center"
                }
              >
                Verify
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  // console.log("testte", state);
  return {
    user: state.user,
    userDetails: state,
  };
}

export default withRouter(connect(mapStateToProps, {
  getUserDetail,
  CreditAssist ,
  getWhatsappNumber,
  updateWhatsappNumber,
  getDocumentStatus,
  getRedirctionSahmati,
})(VerifyWhatsApp))
